module.exports = __webpack_public_path__ + "static/img/homeleft31.bc776e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homeleft31.png
// module id = gUqB
// module chunks = 13